module.exports = __webpack_public_path__ + "static/media/default-profile-cover.f691e41d.png";